import * as actions from "./actions";
const initialState = {
    name: "",
    email: "",
    mobileNumber: ""
};
const contactUsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.CONTACT_US_GET_ACCOUNT_HOLDER_SUCCESS:
            const response = action.payload;
            return {
                name: response.name,
                email: response.email,
                mobileNumber: response.mobileNumber
            };
    }
    return state;
};
export default contactUsReducer;
